"use strict";

angular.module("models").service("OperatorsService", ["ApiService", "UsersService", function (ApiService, UsersService) {
  var that = this;

  var params = {
    name: "operators",
    customPath: "users",
    attributesForCache: ["lastName", "firstName", "calendarColor"],
    formatName: function formatName(element) {
      return element ? that.getName(element) : "???";
    }
    //defaultOrder: {date: -1},
  };

  angular.extend(that, ApiService.getModelBis(params));

  that.getName = function (o) {
    if (o) {
      var name = "";

      if (o.lastName) {
        name += o.lastName.toUpperCase() + " ";
      }

      if (o.firstName) {
        name += o.firstName.charAt(0).toUpperCase() + o.firstName.slice(1).toLowerCase();
      }
      return name;
    } else {
      return "N.C.";
    }
  };

  that.get = function () {
    return new Promise(function (resolve, reject) {
      try {
        UsersService.customGet("operators").then(function (values) {
          resolve(values);
        });
      } catch (error) {
        reject(error);
      }
    });
  };

  that.getSelectArray = function () {
    return new Promise(function (resolve, reject) {
      that.get().then(function (values) {
        var array = [];

        for (var index = 0; index < values.length; index++) {
          var response = values[index];

          array.push({
            name: response.firstName + " " + response.lastName,
            value: "$" + response._id
          });
        }

        resolve(array);
      });
    });
  };
}]);